import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { newsListAction } from "redux/actions/NewsActions/newsListActions";
import { RootState } from "redux/rootReducer";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import NewsCard from "pages/News/NewsCard";

const LatestNews = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(newsListAction());
  }, [dispatch]);

  const { newsList, newsListLoading } = useSelector(
    (state: RootState) => state.newsListReducer
  );

  return (
    <section className="w-full">
      <div className="mainContainer w-full h-full">
        {/* main header  *******************************/}
        <div
          className={`my-[40px] flex items-center justify-center text-second_color text-[32px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600]`}
        >
          <p>{t("Media Center")}</p>
        </div>

        {/* Latest News: *******************************/}
        <div
          className={`my-[30px] px-[40px] lg:px-0 text-second_color text-[25px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600]`}
        >
          <p>{t("Latest News")}:</p>
        </div>

        {/* news Center card section  ******************/}
        <Spin spinning={newsListLoading}>
          <div
            data-aos="fade-up"
            data-aos-duration="1000"
            className="px-[40px] lg:px-0 flex flex-wrap items-center justify-center xl:gap-[20px] "
          >
            <div className="w-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-4 gap-[20px] xl:gap-[60px]">
              {newsList?.data
                ?.slice(0, 4)
                ?.map((singleNews: any, i: number) => {
                  return (
                    <Spin key={i} spinning={newsListLoading}>
                      <NewsCard data={singleNews} />
                    </Spin>
                  );
                })}
            </div>
          </div>
        </Spin>
      </div>
    </section>
  );
};

export default LatestNews;
